<div class="dialog-wrapper">
    <div class="row">    
        <div class="col-sm-10">
                <mat-label class="dialog-title">Lookup Records</mat-label>
        </div>
        <div class="col-sm-2">
            <mat-icon (click)="onClose()">close</mat-icon>
        </div>
        <div class="col-sm-12">
            <mat-form-field class="full-width select-records">
                <mat-label>Select record</mat-label>
                <mat-select [formControl]="damageMechanismsFormControl" multiple [compareWith]="compareById">
                    <mat-option *ngFor="let damageMechanism of damageMechanisms$ | async" [value]="damageMechanism">
                        {{damageMechanism.title}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-12">
            <mat-chip-set>
                <mat-chip
                    *ngFor="let selectedDamageMechanism of damageMechanismsFormControl.value"
                    [removable]="true"
                    (removed)="removeItem(selectedDamageMechanism)">
                    {{selectedDamageMechanism.title}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
            </mat-chip-set>
        </div>
    </div>
    
    <div class="row controls">
        <div class="col-sm-12">
            <button mat-button (click)="onAdd()">Add</button>
            <button mat-button (click)="onClose()">Cancel</button>
        </div>
    </div>
</div>